import React from 'react'
import PageConfig from '@/component/layout/PageConfig.tsx'
import { TYPE_TopNav } from '@/component/layout/TopNav/TopNav.tsx'
import Footer from '@/component/layout/Footer/Footer.tsx'

const PrivacyPage: React.FC = () => {
    return (
        <PageConfig showTopNav={true} typeTopNav={TYPE_TopNav.GUIDE}>
            <div className={'section_800 py-[60px] md:py-[30px] px-[24px]'}>
                <h1 className={'text-[28px] md:text-[22px] font-bold mb-[32px]'}>개인정보처리방침</h1>
                <p className={'text-[14px] text-gray4 leading-[1.8] mb-[32px]'}>
                    돌봄드림 주식회사(이하 "회사")는 Carearly 서비스 제공을 위하여 이용자의 개인정보를 수집·이용하며, 관련 법령에 따라 개인정보를 안전하게 처리하고 보호하고자 다음과 같이 개인정보처리방침을 수립·공개합니다.
                </p>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제1조 (수집하는 개인정보 항목)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집할 수 있습니다.
                    </p>
                    <h3 className={'text-[15px] font-semibold mt-[16px] mb-[8px]'}>1. 회원가입 및 계정관리</h3>
                    <ul className={'text-[14px] text-gray4 leading-[1.8] list-disc pl-[20px]'}>
                        <li>이름</li>
                        <li>휴대전화번호</li>
                        <li>이메일</li>
                        <li>아이디 또는 계정 식별정보</li>
                        <li>비밀번호</li>
                    </ul>
                    <h3 className={'text-[15px] font-semibold mt-[16px] mb-[8px]'}>2. 서비스 이용 과정에서 생성 또는 수집되는 정보</h3>
                    <ul className={'text-[14px] text-gray4 leading-[1.8] list-disc pl-[20px]'}>
                        <li>보호 대상자 정보</li>
                        <li>디바이스 정보</li>
                        <li>접속 로그</li>
                        <li>IP 주소</li>
                        <li>쿠키</li>
                        <li>서비스 이용 기록</li>
                        <li>앱 버전 및 OS 정보</li>
                    </ul>
                    <h3 className={'text-[15px] font-semibold mt-[16px] mb-[8px]'}>3. 위치기반 서비스 이용 시</h3>
                    <ul className={'text-[14px] text-gray4 leading-[1.8] list-disc pl-[20px]'}>
                        <li>개인위치정보</li>
                        <li>위치기록</li>
                        <li>위치정보 이용 관련 로그</li>
                    </ul>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제2조 (개인정보 수집 및 이용 목적)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 수집한 개인정보를 다음 목적을 위해 이용합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회원 식별 및 계정관리</li>
                        <li>보호 대상자 관리 및 돌봄 서비스 제공</li>
                        <li>위치 기반 안전관리 및 알림 제공</li>
                        <li>낙상 감지 및 긴급상황 대응</li>
                        <li>고객문의 응대 및 공지사항 전달</li>
                        <li>서비스 품질 개선 및 통계 분석</li>
                        <li>법령상 의무 이행 및 분쟁 대응</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제3조 (개인정보 보유 및 이용기간)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.</li>
                        <li>다만 관련 법령에 따라 보관이 필요한 경우 해당 법령에서 정한 기간 동안 보관할 수 있습니다.</li>
                        <li>위치정보 및 위치기록의 보유기간은 별도의 위치정보 이용약관 또는 관련 법령에 따릅니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제4조 (개인정보의 제3자 제공)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        다만 다음의 경우에는 예외로 합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>이용자가 사전에 동의한 경우</li>
                        <li>법령에 근거가 있는 경우</li>
                        <li>생명, 신체, 재산 보호 등 긴급한 사유가 있는 경우</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제5조 (개인정보 처리의 위탁)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        회사는 원활한 서비스 제공을 위해 필요한 경우 개인정보 처리업무를 외부에 위탁할 수 있으며, 이 경우 관련 법령에 따라 필요한 사항을 공개합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제6조 (이용자의 권리 및 행사방법)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        이용자는 언제든지 자신의 개인정보에 대해 다음 권리를 행사할 수 있습니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>개인정보 열람 요구</li>
                        <li>개인정보 정정·삭제 요구</li>
                        <li>개인정보 처리정지 요구</li>
                        <li>동의 철회 요구</li>
                    </ol>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mt-[8px]'}>
                        회사는 관련 법령에 따라 이용자의 권리행사를 지체 없이 처리합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제7조 (개인정보의 파기절차 및 방법)</h2>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>회사는 개인정보 보유기간의 경과, 처리목적 달성 등으로 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 정보를 파기합니다.</li>
                        <li>전자적 파일 형태의 정보는 복구 또는 재생되지 않도록 기술적 방법을 사용하여 파기합니다.</li>
                        <li>종이 문서에 기록된 개인정보는 분쇄하거나 소각하여 파기합니다.</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제8조 (개인정보의 안전성 확보조치)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취합니다.
                    </p>
                    <ol className={'text-[14px] text-gray4 leading-[1.8] list-decimal pl-[20px]'}>
                        <li>관리적 조치: 내부관리계획 수립 및 시행, 접근권한 관리</li>
                        <li>기술적 조치: 접근통제, 암호화, 보안프로그램 운영</li>
                        <li>물리적 조치: 전산실 및 자료보관실 접근통제</li>
                    </ol>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제9조 (쿠키의 사용)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        회사는 서비스 이용 편의성 향상 및 서비스 개선을 위해 쿠키를 사용할 수 있습니다. 이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있으나, 이 경우 일부 서비스 이용에 제한이 있을 수 있습니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제10조 (개인정보 보호책임자)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8] mb-[8px]'}>
                        회사는 개인정보 보호와 관련한 업무를 총괄하여 책임지는 개인정보 보호책임자를 지정합니다.
                    </p>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        담당부서 : 서비스 운영팀<br />
                        이메일 : dev@dolbomdream.com
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제11조 (고지의 의무)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        본 개인정보처리방침의 내용 추가, 삭제 및 수정이 있는 경우 회사는 서비스 홈페이지 또는 앱을 통해 사전에 공지합니다.
                    </p>
                </section>

                <section className={'mb-[28px]'}>
                    <h2 className={'text-[18px] font-bold mb-[12px]'}>제12조 (시행일)</h2>
                    <p className={'text-[14px] text-gray4 leading-[1.8]'}>
                        본 방침은 2024년 1월 1일부터 시행합니다.
                    </p>
                </section>
            </div>
            <Footer />
        </PageConfig>
    )
}

export default PrivacyPage
